import React from 'react';
import StepFormWidget from '../StepFormWidget/StepFormWidget';
import { useModal } from '../../context/ModalContext';
import './Hero.css';

const Hero = () => {
  const { openModal } = useModal();
  const avatars = [
    'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=64&q=80',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=64&q=80',
    'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=64&q=80',
    'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=64&q=80'
  ];

  return (
    <section className="hero" id="home">
      <div className="hero-inner">

        {/* Left content */}
        <div className="hero-left">
          <div className="hero-badge">
            <span className="badge-dot">LIVE</span>
            <span className="badge-text">2026 MBBS Admissions — Seats Filling Fast</span>
          </div>
          <h1>Find Your Perfect <span className="grad">Medical College</span> — India or Abroad</h1>
          <p>Get expert NEET counselling and MBBS admission guidance
            for India and Abroad. Discover the best medical colleges
            based on your NEET score and budget — 100% free.</p>
          <div className="hero-ctas">
            <button onClick={openModal} className="btn-primary">Get Free Counselling →</button>
           
          </div>
          <div className="hero-trust">
            <div className="trust-avatars">
              {avatars.map((avatar, idx) => (
                <img key={idx} src={avatar} alt="" />
              ))}
            </div> 
            <div className="trust-text">Trusted by <strong>2,500+ NEET Students</strong> Since 2019</div>
          </div>
        </div>

        {/* Right: Step Form */}
        <div className="hero-right hero-form-side">
          <div className="hero-form-header">
            <div className="hfh-badge">
              <span className="hfh-dot"></span>
              Free Counselling — No Obligation
            </div>
            <p className="hfh-sub">Fill in your details · Expert callback within 24 hrs</p>
          </div>
          <StepFormWidget />
        </div>

      </div>
    </section>
  );
};

export default Hero;